import ga from './ga';
// import linkedin from './linkedin';

export default (analyticsCookies = false, marketingCookies = false) => {
  // console.log('runOnMount', { analyticsCookies, marketingCookies });

  if (analyticsCookies) {
    ga(analyticsCookies, marketingCookies);
  }

  try {
    window.sznIVA.IS.updateIdentities({
      eid: null
    });
  } catch {}

  try {
    window.rc.retargetingHit({ rtgId: 1507293, consent: marketingCookies ? 1 : 0 });
  } catch {}

  // if (marketingCookies) {
  //   linkedin();
  // }
};
